import { render } from "./SelectPartner.vue?vue&type=template&id=9139612a&scoped=true"
import script from "./SelectPartner.vue?vue&type=script&lang=js"
export * from "./SelectPartner.vue?vue&type=script&lang=js"

import "./SelectPartner.vue?vue&type=style&index=0&id=9139612a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9139612a"]])

export default __exports__